import React, { Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext";
import AnnouncementBar from "./components/AnnouncementBar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingApply from "./components/FloatingApply";
import SearchModal from "./components/SearchModal";
import ECEInfrastructure from "./pages/departments/UG/ECEInfrastructure";

const lazyPage = (loader) => React.lazy(loader);
const Home = lazyPage(() => import("./pages/Home"));
const About = lazyPage(() => import("./pages/About"));
const Academics = lazyPage(() => import("./pages/Academics"));
const Admissions = lazyPage(() => import("./pages/Admissions"));
const Recrutement = lazyPage(() => import("./pages/Recrutement"));
const Research = lazyPage(() => import("./pages/Research"));
const Campus = lazyPage(() => import("./pages/Campus"));
const NewsEvents = lazyPage(() => import("./pages/NewsEvents"));
const DepartmentNewsEvents = lazyPage(() => import("./pages/DepartmentNewsEvents"));
const AboutVDIT = lazyPage(() => import("./pages/AboutVDIT"));
const AboutKLS = lazyPage(() => import("./pages/AboutKLS"));
const ChairmansMessage = lazyPage(() => import("./pages/ChairmansMessage"));
const PrincipalsMessage = lazyPage(() => import("./pages/PrincipalsMessage"));
const Leadership = lazyPage(() => import("./pages/Leadership"));
const VisionMission = lazyPage(() => import("./pages/VisionMission"));
const OurHistory = lazyPage(() => import("./pages/OurHistory"));
const GoverningBodies = lazyPage(() => import("./pages/GoverningBodies"));
const People = lazyPage(() => import("./pages/People"));
const Rules = lazyPage(() => import("./pages/Rules"));
const RTI = lazyPage(() => import("./pages/RTI"));
const MandatoryDisclosure = lazyPage(() => import("./pages/MandatoryDisclosure"));
const FinancialStatements = lazyPage(() => import("./pages/FinancialStatements"));
const ProgrammeDetail = lazyPage(() => import("./pages/ProgrammeDetail"));
const CSE = lazyPage(() => import("./pages/departments/UG/CSE"));
const CSEAIML = lazyPage(() => import("./pages/departments/UG/CSEAIML"));
const CSEAIDS = lazyPage(() => import("./pages/departments/UG/CSEAIDS"));
const ECE = lazyPage(() => import("./pages/departments/UG/ECE"));
const EEE = lazyPage(() => import("./pages/departments/UG/EEE"));
const Mechanical = lazyPage(() => import("./pages/departments/UG/Mechanical"));
const Civil = lazyPage(() => import("./pages/departments/UG/Civil"));
const BasicScience = lazyPage(() => import("./pages/departments/UG/BasicScience"));
const CSEInfrastructure = lazyPage(() => import("./pages/departments/UG/CSEInfratsructure"));
const AIMLInfrastructure = lazyPage(() => import("./pages/departments/UG/AIMLInfrastructure"));
const CivilInfrastructure = lazyPage(() => import("./pages/departments/UG/CivilInfrastructure"));
const EEEInfrastructure = lazyPage(() => import("./pages/departments/UG/EEEInfrastructure"));
const MechanicalInfrastructure = lazyPage(() => import("./pages/departments/UG/MechanicalInfrastructure"));
const Physics = lazyPage(() => import("./pages/departments/UG/Physics"));
const Chemistry = lazyPage(() => import("./pages/departments/UG/Chemistry"));
const Maths = lazyPage(() => import("./pages/departments/UG/Maths"));
const English = lazyPage(() => import("./pages/departments/UG/English"));
const PhysicsInfrastructure = lazyPage(() => import("./pages/departments/UG/PhysicsInfrastructure"));
const ChemistryInfrastructure = lazyPage(() => import("./pages/departments/UG/ChemistryInfrastructure"));
const MathsInfrastructure = lazyPage(() => import("./pages/departments/UG/MathsInfrastructure"));
const EnglishInfrastructure = lazyPage(() => import("./pages/departments/UG/EnglishInfrastructure"));
const AIMLResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/AIMLResources"));
const CSEAIDSResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/CSEAIDSResources"));
const BSHResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/BSHResouces"));
const CivilResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/CivilResources"));
const CSEResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/CSEResources"));
const ECEResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/ECEResources"));
const EEEResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/EEEresources"));
const MechanicalResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/MechanicalResources"));
const PhysicsResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/PhysicsResources"));
const ChemistryResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/ChemistryResources"));
const MathematicsResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/MathematicsResources"));
const EnglishResources = lazyPage(() => import("./pages/departments/UG/facultyData/StudentResources/EnglishResources"));
const IndustrialElectronics = lazyPage(() => import("./pages/departments/PG/IndustrialElectronics"));
const ThermalPowerEngineering = lazyPage(() => import("./pages/departments/PG/ThermalPowerEngineering"));
const IndustrialElectronicsFacilities = lazyPage(() => import("./pages/departments/PG/IndustrialElectronicsFacilities"));
const ThermalPowerFacilities = lazyPage(() => import("./pages/departments/PG/ThermalPowerFacilities"));
const CSEResearchCentre = lazyPage(() => import("./pages/departments/ResearchCentres/CSEResearchCentre"));
const ECEResearchCentre = lazyPage(() => import("./pages/departments/ResearchCentres/ECEResearchCentre"));
const EEEResearchCentre = lazyPage(() => import("./pages/departments/ResearchCentres/EEEResearchCentre"));
const MechanicalResearchCentre = lazyPage(() => import("./pages/departments/ResearchCentres/MechanicalResearchCentre"));
const PhysicsResearchCentre = lazyPage(() => import("./pages/departments/ResearchCentres/PhysicsResearchCentre"));
const ChemistryResearchCentre = lazyPage(() => import("./pages/departments/ResearchCentres/ChemistryResearchCentre"));
const MathematicsResearchCentre = lazyPage(() => import("./pages/departments/ResearchCentres/MathematicsResearchCentre"));
const Placements = lazyPage(() => import("./pages/Placements"));
const Library = lazyPage(() => import("./pages/Library"));
const LibraryInfrastructure = lazyPage(() => import("./pages/LibraryInfrastructure"));
const QuestionPaper = lazyPage(() => import("./pages/QuestionPaper"));
const Alumni = lazyPage(() => import("./pages/Alumni"));
const Students = lazyPage(() => import("./pages/Students"));
const FacultyProfile = lazyPage(() => import("./pages/FacultyProfile"));
const NewsDetail = lazyPage(() => import("./pages/NewsDetail"));
const EventDetail = lazyPage(() => import("./pages/EventDetail"));
const Announcements = lazyPage(() => import("./pages/Announcements"));
const AnnouncementDetail = lazyPage(() => import("./pages/AnnouncementDetail"));
const StudentClubs = lazyPage(() => import("./pages/StudentClubs"));
const Associations = lazyPage(() => import("./pages/Associations"));
const Clubs = lazyPage(() => import("./pages/Clubs"));
const RedRibbonClub = lazyPage(() => import("./pages/RedRibbonClub"));
const RedCrossClub = lazyPage(() => import("./pages/RedCrossClub"));
const KalpavrukshaKannadaSangha = lazyPage(() => import("./pages/KalpavrukshaKannadaSangha"));
const Nss = lazyPage(() => import("./pages/Nss"));
const StandardsClub = lazyPage(() => import("./pages/StandardsClub"));
const CentreOfExcellence = lazyPage(() => import("./pages/CentreOfExcellence"));
const COEDetail = lazyPage(() => import("./pages/COEDetail"));
const COERoyalEnfieldInfrastructure = lazyPage(() => import("./pages/COERoyalEnfieldInfrastructure"));
const Sustainability = lazyPage(() => import("./pages/Sustainability"));
const AwardsRecognition = lazyPage(() => import("./pages/AwardsRecognition"));
const AssociationDetail = lazyPage(() => import("./pages/AssociationDetail"));
const IEIActivities = lazyPage(() => import("./pages/IEIActivities"));
const IEIFacultyMembers = lazyPage(() => import("./pages/IEIFacultyMembers"));
const IEIStudentMembers = lazyPage(() => import("./pages/IEIStudentMembers"));
const IeeeAboutUs = lazyPage(() => import("./pages/IeeeAboutUs"));
const IeeeEvents = lazyPage(() => import("./pages/IeeeEvents"));
const IeeeExecom = lazyPage(() => import("./pages/IeeeExecom"));
const CampusLifeDetail = lazyPage(() => import("./pages/CampusLifeDetail"));
const Hostels = lazyPage(() => import("./pages/campus-life/Hostels"));
const BoysHostel = lazyPage(() => import("./pages/campus-life/BoysHostel"));
const GirlsHostel = lazyPage(() => import("./pages/campus-life/GirlsHostel"));
const MessAndCanteen = lazyPage(() => import("./pages/campus-life/MessAndCanteen"));
const Transportation = lazyPage(() => import("./pages/campus-life/Transportation"));
const Atm = lazyPage(() => import("./pages/campus-life/Atm"));
const WifiCampus = lazyPage(() => import("./pages/campus-life/WifiCampus"));
const SolarRooftop = lazyPage(() => import("./pages/campus-life/SolarRooftop"));
const ComputerCenter = lazyPage(() => import("./pages/campus-life/ComputerCenter"));
const CooperativeSociety = lazyPage(() => import("./pages/campus-life/CooperativeSociety"));
const WeldingResearchCenter = lazyPage(() => import("./pages/campus-life/WeldingResearchCenter"));
const IITBombaySpokenTutorial = lazyPage(() => import("./pages/campus-life/IITBombaySpokenTutorial"));
const SportsGymInfrastructure = lazyPage(() => import("./pages/campus-life/SportsGymInfrastructure"));
const SportsAchievementDetail = lazyPage(() => import("./pages/campus-life/SportsAchievementDetail"));
const EcoClub = lazyPage(() => import("./pages/campus-life/EcoClub"));
const AICTE = lazyPage(() => import("./pages/disclosure/AICTE"));
const VTU = lazyPage(() => import("./pages/disclosure/VTU"));
const NAAC = lazyPage(() => import("./pages/disclosure/NAAC"));
const NIRF = lazyPage(() => import("./pages/disclosure/NIRF"));
const IQAC = lazyPage(() => import("./pages/disclosure/IQAC"));
const Governance = lazyPage(() => import("./pages/disclosure/Governance"));
const DELNET = lazyPage(() => import("./pages/disclosure/DELNET"));

const Forum = () => (
  <main className="max-w-5xl mx-auto px-6 lg:px-10 py-24 min-h-[60vh]">
    <h1
      className="text-4xl md:text-5xl text-brand font-semibold mb-4"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      VDIT Forum
    </h1>
    <p className="text-[#2a2a2a]/85 leading-relaxed">
      The VDIT Forum is a peer-reviewed publication featuring student and
      faculty perspectives on engineering, technology, and society. Issues are
      released bi-annually and are open access.
    </p>
  </main>
);

const RouteFallback = () => (
  <main className="min-h-[60vh] flex items-center justify-center px-6">
    <div className="h-10 w-10 rounded-full border-2 border-brand/20 border-t-brand animate-spin" />
  </main>
);

function App() {
  const [searchOpen, setSearchOpen] = React.useState(false);

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <AnnouncementBar onSearchOpen={() => setSearchOpen(true)} />
          <Header />
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
            {/* About + sub */}
            <Route path="/about" element={<Navigate to="/about/about-kls" replace />} />
            <Route path="/about/about-kls" element={<AboutKLS />} />
            <Route path="/about/about-vdit" element={<AboutVDIT />} />
            <Route path="/about/chairmans-message" element={<ChairmansMessage />} />
            <Route path="/about/principals-message" element={<PrincipalsMessage />} />
            <Route path="/about/leadership" element={<Leadership />} />
            <Route path="/about/vision-mission" element={<VisionMission />} />
            <Route path="/about/our-history" element={<OurHistory />} />
            <Route path="/about/governing-bodies" element={<GoverningBodies />} />
            <Route path="/about/people" element={<People />} />
            <Route path="/about/committees" element={<Navigate to="/governance" replace />} />
            <Route path="/about/rules" element={<Rules />} />
            <Route path="/about/rti" element={<RTI />} />
            <Route path="/about/iqac" element={<IQAC />} />
            <Route path="/about/nirf" element={<NIRF />} />
            <Route path="/about/mandatory-disclosure" element={<MandatoryDisclosure />} />
            <Route path="/about/financial-statements" element={<FinancialStatements />} />
            {/* Legacy About page */}
            <Route path="/about-legacy" element={<About />} />
            {/* Academics + departments */}
            <Route path="/academics" element={<Academics />} />
            <Route path="/programme/cse" element={<CSE />} />
            <Route path="/programme/cse/infrastructure" element={<CSEInfrastructure />} />
            <Route path="/programme/cse-aiml" element={<CSEAIML />} />
            <Route path="/programme/cse-aiml/infrastructure" element={<AIMLInfrastructure />} />
            <Route path="/programme/cse-aids" element={<CSEAIDS />} />
            <Route path="/programme/ece" element={<ECE />} />
            <Route path="/programme/ece/infrastructure" element={<ECEInfrastructure />} />
            <Route path="/programme/eee" element={<EEE />} />
            <Route path="/programme/eee/infrastructure" element={<EEEInfrastructure />} />
            <Route path="/programme/me" element={<Mechanical />} />
            <Route path="/programme/me/infrastructure" element={<MechanicalInfrastructure />} />
            <Route path="/programme/civil" element={<Civil />} />


            <Route path="/programme/civil/infrastructure" element={<CivilInfrastructure />} />
            <Route path="/programme/bsh" element={<BasicScience />} />
            <Route path="/programme/bsh/physics" element={<Physics />} />
            <Route path="/programme/bsh/physics/infrastructure" element={<PhysicsInfrastructure />} />
            <Route path="/programme/bsh/chemistry" element={<Chemistry />} />
            <Route path="/programme/bsh/chemistry/infrastructure" element={<ChemistryInfrastructure />} />
            <Route path="/programme/bsh/maths" element={<Maths />} />
            <Route path="/programme/bsh/maths/infrastructure" element={<MathsInfrastructure />} />
            <Route path="/programme/bsh/english" element={<English />} />
            <Route path="/programme/bsh/english/infrastructure" element={<EnglishInfrastructure />} />

            <Route path="/programme/cse/student-resources" element={<CSEResources />} />
            <Route path="/programme/cse-aiml/student-resources" element={<AIMLResources />} />
            <Route path="/programme/cse-aids/student-resources" element={<CSEAIDSResources />} />
            <Route path="/programme/ece/student-resources" element={<ECEResources />} />
            <Route path="/programme/eee/student-resources" element={<EEEResources />} />
            <Route path="/programme/me/student-resources" element={<MechanicalResources />} />
            <Route path="/programme/civil/student-resources" element={<CivilResources />} />
            <Route path="/programme/bsh/student-resources" element={<BSHResources />} />
            <Route path="/programme/bsh/physics/student-resources" element={<PhysicsResources />} />
            <Route path="/programme/bsh/chemistry/student-resources" element={<ChemistryResources />} />
            <Route path="/programme/bsh/maths/student-resources" element={<MathematicsResources />} />
            <Route path="/programme/bsh/english/student-resources" element={<EnglishResources />} />
            <Route path="/programme/:id/news-events" element={<DepartmentNewsEvents />} />
            <Route path="/student-resources/physics" element={<Navigate to="/programme/bsh/physics/student-resources" replace />} />

            <Route path="/programme/industrial-electronics" element={<IndustrialElectronics />} />
            <Route path="/programme/industrial-electronics/facilities" element={<IndustrialElectronicsFacilities />} />
            <Route path="/programme/thermal-power-engineering" element={<ThermalPowerEngineering />} />
            <Route path="/programme/thermal-power-engineering/facilities" element={<ThermalPowerFacilities />} />
            <Route path="/programme/cse-research" element={<CSEResearchCentre />} />
            <Route path="/programme/cse-research-centre" element={<CSEResearchCentre />} />
            <Route path="/programme/ece-research" element={<ECEResearchCentre />} />
            <Route path="/programme/eee-research" element={<EEEResearchCentre />} />
            <Route path="/programme/me-research" element={<MechanicalResearchCentre />} />
            <Route path="/programme/physics" element={<PhysicsResearchCentre />} />
            <Route path="/programme/chemistry" element={<ChemistryResearchCentre />} />
            <Route path="/programme/mathematics" element={<MathematicsResearchCentre />} />
            <Route path="/programme/:id" element={<ProgrammeDetail />} />
            {/* Other top-level */}
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/recrutement" element={<Recrutement />} />
            <Route path="/recruitment" element={<Recrutement />} />
            <Route path="/research" element={<Research />} />
            <Route path="/campus" element={<Campus />} />
            <Route path="/campus-life/hostels" element={<Hostels />} />
            <Route
              path="/campus-life/Hostels"
              caseSensitive
              element={<Navigate to="/campus-life/hostels" replace />}
            />
            <Route path="/campus-life/boys-hostel" element={<BoysHostel />} />
            <Route path="/campus-life/girls-hostel" element={<GirlsHostel />} />
            <Route path="/campus-life/mess-and-canteen" element={<MessAndCanteen />} />
            <Route path="/campus-life/transportation" element={<Transportation />} />
            <Route path="/campus-life/atm" element={<Atm />} />
            <Route path="/campus-life/wifi-campus" element={<WifiCampus />} />
            <Route path="/campus-life/solar-rooftop" element={<SolarRooftop />} />
            <Route path="/campus-life/computer-center" element={<ComputerCenter />} />
            <Route path="/campus-life/cooperative-society" element={<CooperativeSociety />} />
            <Route path="/campus-life/welding-research-center" element={<WeldingResearchCenter />} />
            <Route path="/campus-life/iit-bombay-spoken-tutorial" element={<IITBombaySpokenTutorial />} />
            <Route path="/campus-life/sports-gym/infrastructure" element={<SportsGymInfrastructure />} />
            <Route path="/campus-life/:slug/:section" element={<CampusLifeDetail />} />
            <Route path="/news-events" element={<NewsEvents />} />
            <Route path="/placements" element={<Placements />} />
            <Route path="/library" element={<Library />} />
            <Route path="/library/infrastructure" element={<LibraryInfrastructure />} />
            <Route path="/library/question-paper" element={<QuestionPaper />} />
            <Route path="/alumni" element={<Alumni />} />
            <Route path="/students" element={<Students />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/associations" element={<Associations />} />
            <Route path="/associations/ieee/about-us" element={<IeeeAboutUs />} />
            <Route path="/associations/ieee/events" element={<IeeeEvents />} />
            <Route path="/associations/ieee/execom" element={<IeeeExecom />} />
            <Route path="/associations/iei/activities" element={<IEIActivities />} />
            <Route path="/associations/iei/faculty-members" element={<IEIFacultyMembers />} />
            <Route path="/associations/iei/student-members" element={<IEIStudentMembers />} />
            <Route path="/associations/:id" element={<AssociationDetail />} />
            <Route path="/clubs" element={<Clubs />} />
            <Route path="/clubs/red-ribbon" element={<RedRibbonClub />} />
            <Route path="/clubs/red-cross" element={<RedCrossClub />} />
            <Route path="/clubs/kalpavruksha" element={<KalpavrukshaKannadaSangha />} />
            <Route path="/clubs/eco-club" element={<EcoClub />} />
            <Route path="/clubs/nss" element={<Nss />} />
            <Route path="/clubs/standards" element={<StandardsClub />} />
            <Route path="/centre-of-excellence" element={<CentreOfExcellence />} />
            <Route path="/coe/royal-enfield-training-centre/infrastructure" element={<COERoyalEnfieldInfrastructure />} />
            <Route path="/coe/:id" element={<COEDetail />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/awards-recognition" element={<AwardsRecognition />} />
            <Route path="/faculty/:id" element={<FacultyProfile />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/announcements" element={<Announcements />} />

            <Route path="/announcement/:id" element={<AnnouncementDetail />} />
            <Route path="/student-clubs" element={<StudentClubs />} />
            {/* Disclosure */}
            <Route path="/aicte" element={<AICTE />} />
            <Route path="/vtu" element={<VTU />} />
            <Route path="/naac" element={<NAAC />} />
            <Route path="/nirf" element={<NIRF />} />
            <Route path="/iqac" element={<IQAC />} />
            <Route path="/governance" element={<Governance />} />
            <Route path="/delnet" element={<DELNET />} />
            {/* Life */}
            <Route path="/campus-life/sports-gym" element={<Navigate to="/campus-life/sports-gym/overview" replace />} />
            <Route path="/sports/achievements/:slug" element={<SportsAchievementDetail />} />

              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
          <Footer />
          <FloatingApply />
          <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
